import type { ModelTreeItemIconProps } from "./model-tree-item-icon.type";

import ConditionRating from "@/components/Asset/ConditionRating";
import ModelIcon from "@/modules/model-icon";

import { getModelIconKey } from "./model-tree-item-icon.helper";

const ModelTreeItemIcon = ({ item }: ModelTreeItemIconProps) => {
  const { data } = item;

  if ("condition_rating" in data) {
    return <ConditionRating condition={data.condition_rating} />;
  }

  return <ModelIcon model={getModelIconKey(item)} />;
};

export default ModelTreeItemIcon;
